import Navbar from "../components/Navbar";
import {Route, Routes, useLocation} from "react-router-dom";
import Home from "../pages/home";
import Projects from "../pages/projects";
import Resume from "../pages/resume";
import Blog from "../pages/blog";
import Error from "../pages/error";
import {useContext, useEffect} from "react";
import NavigationContext from "../context/NavigationContext/NavigationContext";
import Contact from "../pages/contact";

function  AppRouter (){
    const location = useLocation().pathname
    const{pathName, dispatch} = useContext(NavigationContext);

    useEffect(()=>{
        dispatch({
            type:"CHECK_PATHNAME",
            payload: location
        })
    },[dispatch, location])
    return(
        <>
            <Navbar pathName = {pathName}/>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/projects" element={<Projects/>}/>
                <Route path="/resume" element={<Resume/>}/>
                <Route path="/blog" element={<Blog/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/*" element={<Error/>}/>
            </Routes>
        </>
    )
}

export default AppRouter;